import { Pipe, PipeTransform } from '@angular/core';
import { DataTransformationService } from '@app/common/data-transformation.service';

@Pipe({
  name: 'physicianName'
})
export class PhysicianNamePipe implements PipeTransform {
  constructor(private dataTransformationService: DataTransformationService) {}

  transform(name): string {
    return this.dataTransformationService.providerName(name);
  }
}
